var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero",attrs:{"title":_vm.hero.name}},[_c('img',{staticClass:"hero__img",attrs:{"src":_vm.hero.image,"alt":_vm.hero.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }